import {
  ecwGettingPaymentDataFromVertical as ecwGettingPaymentDataFromVerticalOriginal,
  ecwPsd2OvercaptureFlow as ecwPsd2OvercaptureFlowOriginal,
  fastCheckoutButtonClicked as fastCheckoutButtonClickedOriginal,
  paymentModalClosed as paymentModalClosedOriginal,
  spbButtonRendered as spbButtonRenderedOriginal,
  spbButtonStartInitializationCheckout as spbButtonStartInitializationCheckoutOriginal,
  spbButtonSuccessInitializationCheckout as spbButtonSuccessInitializationCheckoutOriginal,
  spbButtonTrxAuthorized as spbButtonTrxAuthorizedOriginal,
  spbCountryMissed as spbCountryMissedOriginal,
  spbBuyerMissedShippingOrBillingAddressFields as spbBuyerMissedShippingOrBillingAddressFieldsOriginal,
  spbOnPaymentAuthorizedCallbackResult as spbOnPaymentAuthorizedCallbackResultOriginal,
  spbErrorDuringStartInitializationCheckout as spbErrorDuringStartInitializationCheckoutOriginal,
  spbErrorDuringValidationFromVertical as spbErrorDuringValidationFromVerticalOriginal,
  spbShippingMethodChanged as spbShippingMethodChangedOriginal,
  spbShippingMethodNotAccepted as spbShippingMethodNotAcceptedOriginal,
  transaction3DsForm as transaction3DsFormOriginal,
  expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476 as expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Original,
} from '@wix/bi-logger-payments-data/v2';
import {
  type ecwGettingPaymentDataFromVerticalParams as ecwGettingPaymentDataFromVerticalParamsOriginal,
  type ecwPsd2OvercaptureFlowParams as ecwPsd2OvercaptureFlowParamsOriginal,
  type fastCheckoutButtonClickedParams as fastCheckoutButtonClickedParamsOriginal,
  type paymentModalClosedParams as paymentModalClosedParamsOriginal,
  type spbButtonRenderedParams as spbButtonRenderedParamsOriginal,
  type spbButtonStartInitializationCheckoutParams as spbButtonStartInitializationCheckoutParamsOriginal,
  type spbButtonSuccessInitializationCheckoutParams as spbButtonSuccessInitializationCheckoutParamsOriginal,
  type spbButtonTrxAuthorizedParams as spbButtonTrxAuthorizedParamsOriginal,
  type spbCountryMissedParams as spbCountryMissedParamsOriginal,
  type spbBuyerMissedShippingOrBillingAddressFieldsParams as spbBuyerMissedShippingOrBillingAddressFieldsParamsOriginal,
  type spbOnPaymentAuthorizedCallbackResultParams,
  type spbErrorDuringStartInitializationCheckoutParams as spbErrorDuringStartInitializationCheckoutParamsOriginal,
  type spbErrorDuringValidationFromVerticalParams as spbErrorDuringValidationFromVerticalParamsOriginal,
  type spbShippingMethodChangedParams as spbShippingMethodChangedParamsOriginal,
  type spbShippingMethodNotAcceptedParams as spbShippingMethodNotAcceptedParamsOriginal,
  type transaction3DsFormParams as transaction3DsFormParamsOriginal,
  type expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Params as expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476ParamsOriginal,
} from '@wix/bi-logger-payments-data/v2/types';
import { type PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { type PaymentMethodFundingSource, type PaymentsButtonPlace } from '../../../types/PaymentsButtonViewConfig';

export type paymentModalClosedParams = paymentModalClosedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const paymentModalClosed: (p: paymentModalClosedParams) => ReturnType<typeof paymentModalClosedOriginal> =
  paymentModalClosedOriginal;
export type fastCheckoutButtonClickedParams = fastCheckoutButtonClickedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const fastCheckoutButtonClicked: (
  p: fastCheckoutButtonClickedParams,
) => ReturnType<typeof fastCheckoutButtonClickedOriginal> = fastCheckoutButtonClickedOriginal;

export type ecwGettingPaymentDataFromVerticalParams = ecwGettingPaymentDataFromVerticalParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
  stepName: 'initialization' | 'result';
  result?: 'success' | 'failure';
};

export const ecwGettingPaymentDataFromVertical: (
  p: ecwGettingPaymentDataFromVerticalParams,
) => ReturnType<typeof ecwGettingPaymentDataFromVerticalOriginal> = ecwGettingPaymentDataFromVerticalOriginal;

export type spbButtonRenderedParams = spbButtonRenderedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
  renderPlace: PaymentsButtonPlace;
};

export const spbButtonRendered: (p: spbButtonRenderedParams) => ReturnType<typeof spbButtonRenderedOriginal> =
  spbButtonRenderedOriginal;

export type spbButtonStartInitializationCheckoutParams = spbButtonStartInitializationCheckoutParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonStartInitializationCheckout: (
  p: spbButtonStartInitializationCheckoutParams,
) => ReturnType<typeof spbButtonStartInitializationCheckoutOriginal> = spbButtonStartInitializationCheckoutOriginal;

export type spbButtonSuccessInitializationCheckoutParams = spbButtonSuccessInitializationCheckoutParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonSuccessInitializationCheckout: (
  p: spbButtonSuccessInitializationCheckoutParams,
) => ReturnType<typeof spbButtonSuccessInitializationCheckoutOriginal> = spbButtonSuccessInitializationCheckoutOriginal;

export type spbButtonTrxAuthorizedParams = spbButtonTrxAuthorizedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonTrxAuthorized: (
  p: spbButtonTrxAuthorizedParams,
) => ReturnType<typeof spbButtonTrxAuthorizedOriginal> = spbButtonTrxAuthorizedOriginal;

export type spbCountryMissedParams = spbCountryMissedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbCountryMissed: (p: spbCountryMissedParams) => ReturnType<typeof spbCountryMissedOriginal> =
  spbCountryMissedOriginal;

export type spbBuyerMissedShippingOrBillingAddressFieldsParams =
  spbBuyerMissedShippingOrBillingAddressFieldsParamsOriginal & {
    paymentProvider: PaymentProvider;
    paymentMethod: PaymentMethod;
  };

export const spbBuyerMissedShippingOrBillingAddressFields: (
  p: spbBuyerMissedShippingOrBillingAddressFieldsParams,
) => ReturnType<typeof spbBuyerMissedShippingOrBillingAddressFieldsOriginal> =
  spbBuyerMissedShippingOrBillingAddressFieldsOriginal;

export const spbOnPaymentAuthorizedCallbackResult: (
  p: spbOnPaymentAuthorizedCallbackResultParams,
) => ReturnType<typeof spbOnPaymentAuthorizedCallbackResultOriginal> = spbOnPaymentAuthorizedCallbackResultOriginal;

export type spbErrorDuringStartInitializationCheckoutParams =
  spbErrorDuringStartInitializationCheckoutParamsOriginal & {
    paymentProvider: PaymentProvider;
    paymentmethod: PaymentMethodFundingSource;
  };

export const spbErrorDuringStartInitializationCheckout: (
  p: spbErrorDuringStartInitializationCheckoutParams,
) => ReturnType<typeof spbErrorDuringStartInitializationCheckoutOriginal> =
  spbErrorDuringStartInitializationCheckoutOriginal;

export type spbErrorDuringValidationFromVerticalParams = spbErrorDuringValidationFromVerticalParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbErrorDuringValidationFromVertical: (
  p: spbErrorDuringValidationFromVerticalParams,
) => ReturnType<typeof spbErrorDuringValidationFromVerticalOriginal> = spbErrorDuringValidationFromVerticalOriginal;

export type spbShippingMethodChangedParams = spbShippingMethodChangedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbShippingMethodChanged: (
  p: spbShippingMethodChangedParams,
) => ReturnType<typeof spbShippingMethodChangedOriginal> = spbShippingMethodChangedOriginal;

export type spbShippingMethodNotAcceptedParams = spbShippingMethodNotAcceptedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbShippingMethodNotAccepted: (
  p: spbShippingMethodNotAcceptedParams,
) => ReturnType<typeof spbShippingMethodNotAcceptedOriginal> = spbShippingMethodNotAcceptedOriginal;

export type ecwPsd2OvercaptureFlowParams = ecwPsd2OvercaptureFlowParamsOriginal & {
  paymentProvider?: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const ecwPsd2OvercaptureFlow: (
  p: ecwPsd2OvercaptureFlowParams,
) => ReturnType<typeof ecwPsd2OvercaptureFlowOriginal> = ecwPsd2OvercaptureFlowOriginal;

export type transaction3DsFormParams = transaction3DsFormParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const transaction3DsForm: (p: transaction3DsFormParams) => ReturnType<typeof transaction3DsFormOriginal> =
  transaction3DsFormOriginal;

export type expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Params =
  expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476ParamsOriginal;

export const expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476: (
  p: expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Params,
) => ReturnType<typeof expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Original> =
  expressCheckoutWidgetPaymentMethodButtonWasntRenderedSrc64Evid476Original;
